import React, { useEffect, useState } from "react";
import { Form, Row, Col, } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getstudentFeesDetails, addFeeCollection } from "../../store/slices/fees";
import { toast } from "react-hot-toast";
import { FiHome, FiChevronRight } from "react-icons/fi";
import { fetchStandardSection } from "../../store/slices/getstandardsection";
import { getStudent } from "../../store/slices/student";
import Select from "react-select";
import { pdf } from "@react-pdf/renderer";
import FeeReceipt from "./feeReceipt";

export default function FeesCollection() {
  const dispatch = useDispatch();

  const [errors, setErrors] = useState({});
  const currentYear = new Date().getFullYear();
  const currentSession = `${currentYear}-${String(currentYear + 1).slice(-2)}`;
  const [session, setSession] = useState(currentSession);
  const [standardId, setStandardId] = useState("");
  const [studentId, setStudentId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [paymentData, setPaymentData] = useState({});
  const [standards, setStandards] = useState([]);
  const [students, setStudents] = useState([]);
  const [sections, setSections] = useState([]);
  const [modeOfPayment, setModeOfPayment] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [feeDetails, setFeeDetails] = useState([]);
  const today = new Date().toISOString().split("T")[0];


  useEffect(() => {

    dispatch(fetchStandardSection())
      .unwrap()
      .then((res) => {

        setStandards(res.data || []);

      })
      .catch((err) => {

        toast.error(err);

      });

  }, []);

  const validate = () => {
    const newErrors = {};

    if (!session)
      newErrors.session = "Please select session";

    if (!standardId)
      newErrors.standardId = "Please select standard";

    if (!sectionId)
      newErrors.sectionId = "Please select section";

    if (!studentId)
      newErrors.studentId = "Please select student";

    if (!modeOfPayment)
      newErrors.modeOfPayment = "Please select payment mode";

    if (!paymentDate)
      newErrors.paymentDate = "Please select payment date";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleStandardChange = (e) => {

    const value = e.target.value;

    setStandardId(value);

    setSectionId("");

    setStudentId("");

    setStudents([]);

    setFeeDetails([]);

    const selectedStandard = standards.find(
      item => item.standardId._id === value
    );

    if (selectedStandard) {
      setSections(selectedStandard.sectionId);
    } else {
      setSections([]);
    }

  };

  const handleSectionChange = (e) => {

    const value = e.target.value;

    setSectionId(value);

    setStudentId("");

    setFeeDetails([]);

    dispatch(getStudent({
      standardId,
      sectionId: value
    }))
      .unwrap()
      .then((res) => {

        setStudents(res.data || []);

      })
      .catch((err) => {

        toast.error(err);

      });

  };

  const handleStudentChange = (e) => {

    setStudentId(e.target.value);

    setFeeDetails([]);

  };

  const handlePaymentChange = (
    categoryId,
    installmentName,
    field,
    value,
    due
  ) => {
    const key = `${categoryId}_${installmentName}`;

    const current = paymentData[key] || {
      concession: false,
      discountFrom: "",
      discount: "",
      paidAmount: ""
    };

    if (field === "discount" || field === "paidAmount") {
      value = value.replace(/\D/g, "");

      const discount =
        field === "discount"
          ? Number(value || 0)
          : Number(current.discount || 0);

      const paid =
        field === "paidAmount"
          ? Number(value || 0)
          : Number(current.paidAmount || 0);

      if (discount + paid > due) {
        return;
      }
    }

    setPaymentData((prev) => ({
      ...prev,
      [key]: {
        ...current,
        [field]: value
      }
    }));
  };

  const handleSearch = () => {

    if (!validate()) return;

    dispatch(
      getstudentFeesDetails({
        session,
        studentId,
      })
    )
      .unwrap()
      .then((res) => {
        setFeeDetails(res.data);
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  const validatePayment = () => {
    for (const category of feeDetails) {
      for (const item of category.installments) {

        const key = `${category.feeCategoryId}_${item.installmentName}`;

        const payment = paymentData[key];

        if (!payment) continue;

        const discount = Number(payment.discount || 0);
        const paid = Number(payment.paidAmount || 0);

        if (discount + paid > item.due) {
          toast.error(
            `${item.installmentName}: Discount + Amount Paid cannot exceed ₹${item.due}`
          );
          return false;
        }
      }
    }

    return true;
  };

  const handleSave = () => {

    if (!modeOfPayment)
      return toast.error("Select payment mode.");

    if (!paymentDate)
      return toast.error("Select payment date.");

    if (!validatePayment())
      return;


    const payments = [];

    const category = feeDetails[0];


    category.installments.forEach((item) => {

      const key =
        `${category.feeCategoryId}_${item.installmentName}`;

      const row = paymentData[key];

      if (!row) return;

      if (
        Number(row.paidAmount || 0) === 0 &&
        Number(row.discount || 0) === 0
      ) {
        return;
      }


      payments.push({

        installmentName:
          item.installmentName,

        paidAmount:
          Number(row.paidAmount || 0),

        discount:
          Number(row.discount || 0),

        discountFrom:
          row.discountFrom || "",

        remarks:
          row.remarks || ""

      });

    });


    const payload = {

      session,

      studentId,

      standardId,

      sectionId,

      feeCategoryId:
        category.feeCategoryId,

      modeOfPayment,

      paymentDate,

      payments

    };


    dispatch(addFeeCollection(payload))

      .unwrap()

      .then(async (response) => {

        console.log(
          "FEE COLLECTION RESPONSE:",
          response
        );


        toast.success(
          "Fee collected successfully."
        );


        // ======================================
        // GET RECEIPT DATA
        // ======================================

        const fee =
          response?.data || response;


        const institute =
          response?.institute ||
          response?.data?.institute ||
          null;


        console.log(
          "FEE RECEIPT DATA:",
          fee
        );

        console.log(
          "INSTITUTE:",
          institute
        );


        // ======================================
        // GENERATE PDF
        // ======================================

        const blob = await pdf(

          <FeeReceipt
            fee={fee}
            institute={institute}
          />

        ).toBlob();


        const pdfUrl =
          URL.createObjectURL(blob);


        window.open(
          pdfUrl,
          "_blank"
        );


        // Don't reload immediately.
        // User can close the receipt and
        // continue working.

      })

      .catch((err) => {

        console.error(
          "FEE COLLECTION ERROR:",
          err
        );

        toast.error(
          err?.message ||
          err ||
          "Failed to collect fee."
        );

      });

  };

  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">
          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/accounts/home">
                <FiHome style={{ color: "white", marginTop: "-4px" }} />
              </Link>
            </div>
            <FiChevronRight className="separator" />

            <span className="active">Fees Collection</span>
          </div>
        </div>
      </div>
      <div className="acs-card">
        <Form onSubmit={handleSearch}>
          <Row className="g-3 align-items-end">

            {/* Session */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Session</Form.Label>
                <Form.Select
                  value={session}
                  onChange={(e) => setSession(e.target.value)}
                >


                  <option value={currentSession}>
                    {currentSession}
                  </option>

                </Form.Select>
                <div className="text-danger mt-1" >
                  {errors.session}
                </div>
              </Form.Group>
            </Col>

            {/* Standard */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Standard</Form.Label>

                <Form.Select
                  value={standardId}
                  onChange={handleStandardChange}
                >
                  <option value="">Select Standard</option>

                  {standards.map((item) => (

                    <option
                      key={item.standardId._id}
                      value={item.standardId._id}
                    >
                      {item.standardId.name}
                    </option>

                  ))}

                </Form.Select>
                <div className="text-danger mt-1" >
                  {errors.standardId}
                </div>
              </Form.Group>
            </Col>

            {/* Section */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Section</Form.Label>

                <Form.Select
                  value={sectionId}
                  onChange={handleSectionChange}
                  disabled={!standardId}
                >
                  <option value="">Select Section</option>

                  {sections.map((item) => (

                    <option
                      key={item._id}
                      value={item._id}
                    >
                      {item.name}
                    </option>

                  ))}

                </Form.Select>
                <div className="text-danger mt-1" >
                  {errors.sectionId}
                </div>
              </Form.Group>
            </Col>

            {/* Student */}
            <Col md={3}>
              <Form.Group>
                <Form.Label>Student</Form.Label>

                <Select
                  isDisabled={!sectionId}
                  placeholder="Search Student..."
                  value={
                    students
                      .map((item) => ({
                        value: item._id,
                        label: item.name,
                      }))
                      .find((item) => item.value === studentId) || null
                  }
                  options={students.map((item) => ({
                    value: item._id,
                    label: item.name,
                  }))}
                  onChange={(selected) => {
                    setStudentId(selected ? selected.value : "");
                    setFeeDetails([]);
                  }}
                  isClearable
                />
                <div className="text-danger mt-1" >
                  {errors.studentId}
                </div>
              </Form.Group>
            </Col>


            <Col md={3}>
              <Form.Group>
                <Form.Label>Mode of Payment</Form.Label>

                <Form.Select
                  value={modeOfPayment}
                  onChange={(e) => setModeOfPayment(e.target.value)}
                >
                  <option value="">Select Mode</option>

                  <option value="Cash">Cash</option>

                  <option value="UPI">UPI</option>

                  <option value="Card">Card</option>

                  <option value="Bank Transfer">
                    Bank Transfer
                  </option>

                  <option value="Cheque">
                    Cheque
                  </option>

                </Form.Select>
                <div className="text-danger mt-1" >
                  {errors.modeOfPayment}
                </div>

              </Form.Group>
            </Col>



            <Col md={3}>
              <Form.Group>

                <Form.Label>Payment Date</Form.Label>

                <Form.Control
                  type="date"
                  value={paymentDate}
                  max={today}
                  isInvalid={!!errors.paymentDate}
                  onChange={(e) => {
                    setPaymentDate(e.target.value);

                    setErrors(prev => ({
                      ...prev,
                      paymentDate: ""
                    }));
                  }}
                />
                <div className="text-danger mt-1" >
                  {errors.paymentDate}
                </div>
              </Form.Group>
            </Col>
            <Col md={1}>
              <button
                type="button"
                className="btn-submit"
                onClick={handleSearch} style={{ width: "150px" }}
              >
                Search
              </button>
            </Col>


          </Row>
          {feeDetails.length > 0 &&
            feeDetails.map((category) => (
              <div key={category.feeCategoryId} className="mt-4">


                <Row className="fw-bold border-bottom pb-2 mb-3 text-center mt-5">
                  <Col md={2}>Installment</Col>
                  <Col md={1}>Amount</Col>
                  <Col md={1}>Paid</Col>
                  <Col md={1}>Due</Col>
                  <Col md={1}>Concession</Col>
                  <Col md={2}>From</Col>
                  <Col md={2}>Discount Amount</Col>
                  <Col md={2}>Amount Paid</Col>
                </Row>

                {category.installments.map((item, index) => (

                  <Row
                    key={index}
                    className="align-items-center py-3 border-bottom text-center"
                  >

                    {/* Installment */}
                    <Col md={2}>
                      <div className="fw-semibold">
                        {item.installmentName}
                      </div>

                    </Col>

                    {/* Amount */}
                    <Col md={1}>
                      ₹{item.amount}
                    </Col>

                    {/* Already Paid */}
                    <Col md={1}>
                      ₹{item.paid}
                    </Col>

                    {/* Balance */}
                    <Col md={1}>
                      <span className="text-danger fw-bold">
                        ₹{item.due}
                      </span>
                    </Col>

                    {/* Concession */}
                    <Col md={1}>
                      <Form.Check
                        disabled={item.due === 0}
                        checked={
                          paymentData[`${category.feeCategoryId}_${item.installmentName}`]
                            ?.concession || false
                        }
                        onChange={(e) =>
                          handlePaymentChange(
                            category.feeCategoryId,
                            item.installmentName,
                            "concession",
                            e.target.checked,
                            item.due
                          )
                        }
                      />
                    </Col>

                    <Col md={2}>
                      <Form.Select
                        disabled={
                          item.due === 0 ||
                          !paymentData[
                            `${category.feeCategoryId}_${item.installmentName}`
                          ]?.concession
                        }
                        value={
                          paymentData[`${category.feeCategoryId}_${item.installmentName}`]
                            ?.discountFrom || ""
                        }
                        onChange={(e) =>
                          handlePaymentChange(
                            category.feeCategoryId,
                            item.installmentName,
                            "discountFrom",
                            e.target.value,
                            item.due
                          )
                        }
                      >
                        <option value="">From</option>
                        <option value="School">School</option>
                        <option value="Government">Government</option>
                        <option value="Trust">Trust</option>
                      </Form.Select>
                    </Col>

                    <Col md={2}>
                      <Form.Control
                        type="text"
                        inputMode="numeric"
                        placeholder="Discount"
                        disabled={
                          item.due === 0 ||
                          !paymentData[
                            `${category.feeCategoryId}_${item.installmentName}`
                          ]?.concession
                        }
                        value={
                          paymentData[`${category.feeCategoryId}_${item.installmentName}`]
                            ?.discount || ""
                        }
                        onChange={(e) =>
                          handlePaymentChange(
                            category.feeCategoryId,
                            item.installmentName,
                            "discount",
                            e.target.value,
                            item.due
                          )
                        }
                      />
                    </Col>

                    <Col md={2}>
                      <Form.Control
                        type="text"
                        inputMode="numeric"
                        placeholder="Amount Paid"
                        disabled={item.due === 0}
                        value={
                          paymentData[`${category.feeCategoryId}_${item.installmentName}`]
                            ?.paidAmount || ""
                        }
                        onChange={(e) =>
                          handlePaymentChange(
                            category.feeCategoryId,
                            item.installmentName,
                            "paidAmount",
                            e.target.value,
                            item.due
                          )
                        }
                      />
                    </Col>

                  </Row>

                ))}
                <Row className="mt-4">

                  <Col className="text-end">

                    <button
                      type="button"
                      className="btn-submit"
                      onClick={handleSave}
                    >
                      Save
                    </button>

                  </Col>

                </Row>

              </div>
            ))
          }
        </Form>
      </div>
    </>
  );
}